import * as React from "react";
import { Input } from "./components/Input";
import { Wrapper } from "./components/Wrapper";

export interface ISettingTextField {
  value?: any;
  disabled?: boolean;
  onChange?: React.FormEventHandler<HTMLInputElement>;
  theme?: object;
  placeholder?: string;
}

export const SettingTextField = ({
  onChange,
  value,
  ...props
}: ISettingTextField) => {
  return (
    <Wrapper {...props}>
      <Input
        onChange={onChange}
        value={value}
        placeholder={props.placeholder}
        disabled={props.disabled}
        type="text"
      />
    </Wrapper>
  );
};
